/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiResetpasswordMutationRequest,
  PostApiResetpasswordMutationResponse,
} from '../models/PostApiResetpassword.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiResetpasswordMutationResponseSchema,
  postApiResetpasswordMutationRequestSchema,
} from '../zod/postApiResetpasswordSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiResetpasswordMutationKey = () =>
  [{ url: '/api/resetPassword' }] as const;

export type PostApiResetpasswordMutationKey = ReturnType<
  typeof postApiResetpasswordMutationKey
>;

/**
 * {@link /api/resetPassword}
 */
export async function postApiResetpassword(
  data: PostApiResetpasswordMutationRequest,
  config: Partial<RequestConfig<PostApiResetpasswordMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiResetpasswordMutationRequestSchema.parse(data);
  const res = await request<
    PostApiResetpasswordMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiResetpasswordMutationRequest
  >({
    method: 'POST',
    url: `/api/resetPassword`,
    data: requestData,
    ...requestConfig,
  });
  return postApiResetpasswordMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/resetPassword}
 */
export function usePostApiResetpassword<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiResetpasswordMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiResetpasswordMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<PostApiResetpasswordMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiResetpasswordMutationKey();

  return useMutation<
    PostApiResetpasswordMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiResetpasswordMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiResetpassword(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
